import { type RefObject } from 'preact';

import { useEffect, useRef, useState } from 'preact/hooks';

/* eslint-disable react-hooks/exhaustive-deps */
export const useIsInViewport = <Element extends HTMLElement>(
  options: IntersectionObserverInit = {}
): [RefObject<Element>, boolean] => {
  const ref = useRef<Element>(null);

  const [isInView, setIsInView] = useState<boolean>(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      // Only consider the first entry (the element we're observing)
      setIsInView(entries[0].isIntersecting);
    }, options);

    const observableElement = ref.current;

    if (observableElement) {
      observer.observe(observableElement);
    }

    return () => {
      if (observableElement) {
        observer.unobserve(observableElement);
      }

      observer.disconnect();
    };
  }, []);

  return [ref, isInView];
};
